import { render } from "./BarIcon.vue?vue&type=template&id=c0e6e7fa"
import script from "./BarIcon.vue?vue&type=script&lang=js"
export * from "./BarIcon.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__